<template>
    <div class="animated fadeIn">
        <vue-loading :active="isLoading" loader="bars" :is-full-page="false"></vue-loading>
        <b-form>
            <b-form-group v-if="!addOption"
                          label="Membership ID"
                          description="Membership ID"
                          :label-cols="3"
                          :horizontal="true">
                <b-form-input type="text" placeholder="Membership Id" v-model="membership.id" disabled></b-form-input>
            </b-form-group>
            <b-form-group v-if="!addOption"
                          label="Membership Status"
                          description="Membership Status"
                          :label-cols="3"
                          :horizontal="true"
            >
              <app-btn :text="membership.status"></app-btn>
            </b-form-group>
            <b-form-group
                    label="Type"
                    description="Membership Type"
                    :label-cols="3"
                    :horizontal="true">
                <b-form-radio-group  v-model="membership.type"
                                    :plain="true"
                                    :options="[
                                    {text: 'Member', value: 'member'},
                                    {text: 'Active Member', value: 'active_member'}
                                ]"
                                    :checked="membership.type">
                </b-form-radio-group>
            </b-form-group>
          <b-form-group
            v-if="'created' !== membership.status && membership.order !== null && !addOption"
            description="Payment Source"
            label="Payment Source"
            :label-cols="3"
          >
            <b-form-input type="text" v-model="membership.order.paymentSource" disabled></b-form-input>
          </b-form-group>
          <b-form-group
            v-if="addOption"
            description="Membership Start From Today?"
            label="Membership Start From Today?"
            :label-cols="3"
            :horizontal="true">
            <b-form-checkbox checked="true" v-on:change="customDate = customDate ? false : true" ></b-form-checkbox>
          </b-form-group>
            <b-form-group
                    description="Membership Start Date"
                    label="StartAt"
                    :label-cols="3"
                    :horizontal="true"
                    v-show="customDate || !addOption"
            >
                <datepicker  v-model="membership.startAt" input-class="form-control" :disabled="!addOption"></datepicker>
            </b-form-group>
            <b-form-group
                    description="Membership End Date"
                    label="EndAt"
                    :label-cols="3"
                    :horizontal="true"
                    v-show="customDate || !addOption"
            >
                <datepicker  v-model="membership.endAt" input-class="form-control" :disabled="!addOption"></datepicker>
            </b-form-group>
            <strong>Person Details</strong>
            <b-form-group validated
                          label="Person Name"
                          label-for="subscriberName"
                          description="Please enter person name."
                          :label-cols="3"
                          :horizontal="true">
                <b-form-input id="personName" type="text" placeholder="Enter Name.." v-model="membership.person.name" required ></b-form-input>
            </b-form-group>
            <b-form-group validated
                          label="Person Surname"
                          label-for="subscriberSurname"
                          description="Please enter person surname."
                          :label-cols="3"
                          :horizontal="true">
                <b-form-input id="personSurname" type="text" placeholder="Enter Surname.." v-model="membership.person.surname" autocomplete="surname"></b-form-input>
            </b-form-group>
            <b-form-group
                    description="Enter the person email."
                    label="Person Email"
                    :label-cols="3"
                    :horizontal="true">
                <b-form-input  type="email" v-model="membership.person.email" required></b-form-input>
            </b-form-group>
            <b-form-group
                    description="Enter the person mobile."
                    label="Person Mobile"
                    :label-cols="3"
                    :horizontal="true">
                <b-form-input  type="text" v-model="membership.person.mobile"></b-form-input>
            </b-form-group>
            <div slot="footer">
                <b-button type="button" size="sm" variant="primary" v-show="addOption" v-on:click="addMembership" ><i class="fa fa-plus" ></i> Add</b-button>
                <membership-action-buttons
                  :membership="membership"
                  @loading="onIsLoading"
                  @paid="onPaid"
                  @cancelled="onCancelled"
                ></membership-action-buttons>
            </div>
        </b-form>
    </div>
</template>
<script>
    import {RepositoryFactory} from "../../services/repositories/RepositoryFactory";
    import {Membership} from "../../models/Membership"
    import router from '../../router'
    import VueLoading from "vue-loading-overlay/src/js/Component";
    import {handleErrors} from "../../shared/utils";
    import Datepicker from "vuejs-datepicker/src/components/Datepicker";
    import MembershipActionButtons from "./MembershipActionButtons";
    import AppBtn from "../base/AppBtn";

    const MembershipRepo = RepositoryFactory.get('membership')

    export default {
        name: 'membership-form',
        components: {
          AppBtn,
            MembershipActionButtons,
            VueLoading,
            Datepicker,
        },
        props: {
            membership: {
                type: Object,
                default: new Membership(),
            },
            addOption: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                isLoading: false,
                customDate: false,
            }
        },
        watch: {
            'membership.startAt': {
                handler(val) {
                    this.membership.endAt = this.$moment(val).add(1, 'year')
                }
            }
        },
        methods: {
            addMembership () {
                this.isLoading = true
                let postData = {
                    amount: this.membership.amount,
                    type: this.membership.type,
                    customer: {
                        name: this.membership.person.name,
                        surname: this.membership.person.surname,
                        email: this.membership.person.email,
                        mobile: this.membership.person.mobile,
                    }
                }

                if(this.customDate){
                    postData.startAt = this.$moment(this.membership.startAt).format('YYYY-MM-DD')+'T00:00:00+01:00',
                    postData.endAt   = this.$moment(this.membership.endAt).format('YYYY-MM-DD')+'T00:00:00+01:00'
                }

                MembershipRepo
                    .createMember(postData)
                    .then(response => (
                        router.push({name: 'member', params: {memberId: response.data.data.id}})
                    )).catch(response => (
                        this.returnErrors(response)
                    )
                )
            },
            onCancelled(member) {
                this.isLoading = false,
                this.membership = new Membership(member),
                this.flash('Membership has been cancelled','success')
            },
            onPaid(member) {
                this.isLoading = false,
                this.membership = new Membership(member),
                this.flash('Paid Membership ','success')
            },
            onIsLoading() {
                this.isLoading = true
            },
            returnErrors(response) {
                handleErrors(response).forEach(
                    value => {
                        this.flash(value,'error')
                    }
                ),
                this.isLoading = false
            },
        }
    }
</script>
